const CheckboxFive = (props: any) => {
  return (
    <div>
      <label
        htmlFor={props.id}
        className="flex cursor-pointer select-none items-center"
      >
        <div className="relative">
          <input
            type="checkbox"
            id={props.id}
            value={props.id}
            className="sr-only"
            onChange={props.onChange}
          />
          <div
            className={`box mr-4 flex h-5 w-5 items-center justify-center rounded-full border border-primary ${
              props.isChecked && '!border-4'
            }`}
          >
            <span className="h-2.5 w-2.5 rounded-full bg-white dark:bg-transparent"></span>
          </div>
        </div>
        {props.label}
      </label>
    </div>
  );
};

export default CheckboxFive;
